export default {
  // 审批锁价订单
  approvalYxPriceOrder: '/ygsjzs/yxPriceOrder/approvalYxPriceOrder',

  // 删除锁价订单
  deleteYxPriceOrder: '/ygsjzs/yxPriceOrder/deleteYxPriceOrder',

  // 新增锁价订单
  insertYxPriceOrder: '/ygsjzs/yxPriceOrder/insertYxPriceOrder',

  // 修改锁价订单
  updateYxPriceOrder: '/ygsjzs/yxPriceOrder/updateYxPriceOrder',

  // 查询锁价订单详情
  selectYxPriceOrderByOrderId: '/ygsjzs/yxPriceOrder/selectYxPriceOrderByOrderId',
  // 分页查询锁价订单列表
  selectYxPriceOrderByPage: '/ygsjzs/yxPriceOrder/selectYxPriceOrderByPage',
  // 导出
  exportYxPriceOrder: '/ygsjzs/yxPriceOrder/exportYxPriceOrder',
  // 点价时间配置
  updateYxStatus: '/ygsjzs/YxGdx/updateYxStatus',
  selectYxStatus: '/ygsjzs/YxGdx/selectYxStatus',

  // 提货日期、
  updateYxPriceOrderDate: '/ygsjzs/yxPriceOrder/updateYxPriceOrderDate'
}
